<app-breadcrumb [home]="home" [items]="breadcrumbs" />

@if (loading() && !view()) {
  <div class="client-loading" role="status" aria-label="Carregando">
    <app-cog-loading-spinner [size]="64" />
  </div>
} @else if (errorMessage()) {
  <div class="client-deal__error" role="alert">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>A sua operação não abriu.</strong>
      <p>{{ errorMessage() }}</p>
      <a class="client-deal__back" routerLink="/dashboard/commercial/client"
        >Voltar para Minha operação</a
      >
    </div>
    @if (canRetry()) {
      <app-button
        label="Tentar de novo"
        icon="pi pi-refresh"
        theme="white"
        [type]="'button'"
        (sendButtonClick)="load()" />
    }
  </div>
} @else if (view(); as deal) {
  <header class="client-deal__header">
    <div>
      <h2 class="client-deal__title">Sua jornada com a Legatus</h2>
      <span class="client-deal__company">{{ deal.companyName }}</span>
    </div>

    @if (dealOptions().length > 1) {
      <!-- Empresa com mais de uma operação (caso raro): escolhe qual acompanhar. -->
      <div class="client-deal__switcher">
        <app-select
          [options]="dealOptions()"
          [ngModel]="selectedDealId()"
          (ngModelChange)="openDeal($event)"
          [hasFilter]="false"
          [error]="false"
          aria-label="Operação" />
        <span class="client-deal__switcher-count">{{ dealOptions().length }} operações</span>
      </div>
    }
  </header>

  <!-- Protótipo aprovado em 19/10/2026: jornada 2/3, painel lateral 1/3. -->
  <div class="client-deal__grid">
    <section class="client-deal__journey" aria-label="Etapas da operação">
      <app-client-stage-timeline [steps]="steps()" />
    </section>

    <aside class="client-deal__aside">
      <section class="client-deal-card">
        <h3 class="client-deal-card__title">Próximo passo</h3>
        @if (nextStep(); as next) {
          <p class="client-deal-card__next">{{ next.label }}</p>
          <p class="client-deal-card__text">{{ next.description }}</p>
        } @else {
          <p class="client-deal-card__text">
            Esta é a última etapa. Para qualquer dúvida sobre a operação, fale com o time da
            Legatus.
          </p>
        }
      </section>

      <app-client-signatures-card
        [term]="deal.term"
        [signing]="signing()"
        [signLinkOpened]="signLinkOpened()"
        (sign)="signTerm()"
        (refresh)="load()" />

      <div class="client-deal__privacy" role="note">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <p>
          Este espaço mostra apenas a sua operação. Análises internas e documentos de crédito da
          Legatus não são exibidos aqui.
        </p>
      </div>
    </aside>
  </div>
}
